// activation
$(function () {
    $("#activation").click(function () {
        // let imei = $('#imei').val().trim() || 355049080820184;
        // 使用 MD5(imei + sharedSecret) 生成 key 
        function generateMD5(input) {
          return CryptoJS.MD5(input).toString();
        }
        
        let sharedSecret = "0123456789ABCDEFGHJKLMNOPQRSTUVWXYZ"; // 替换为实际的 SharedSecret

        
        let imei = $("#imei").val().trim();
        let key = generateMD5(imei + sharedSecret); 
        // let api = `https://mg.adups.cn/ota/exportDoogeeImei.do?imeiQY=${imei}`;
        let api = `https://mg.adups.cn/ota/exportDoogeeImei.do?imeiQY=${imei}&key=${key}`; 
        // let api = `https://www.doogee.cc/?do_action=action.getDoogeeImei&imeiQY=${imei}`;
        // console.log(api, "activation");
        let el = $(".check-result");
        let empty = el.find(".check-empty");
        let table = el.find(".table");
        let tbody = el.find("tbody");
        let loading = el.find(".loading");

        table.hide();
        empty.hide();

        // if (!(/^(?:\d{15}|U\d{18})$/.test(imei))) {
        //     empty.show();
        //     return;
        // } else {
        //     loading.show();
        // }

        $.get(api, function (data) {
            // console.log(data, "data")
            let { ImeiList } = data;
            loading.hide();
            // console.log(ImeiList);
            if (!ImeiList.length) { empty.show(); return; }
            let html = ImeiList.map(i => `
            <tr>
                <td>${i.imei1}</td>
                <td>${i.imei2}</td>
                <td>${i.activation_time}</td>
            </tr>
            `).join('');
            table.show();
            tbody.html(html);
        }, 'json')

        // $.get(api, function (data) {
        //   let { ImeiList } = JSON.parse(data);
        //   // console.log(ImeiList);

        //   loading.hide();

        //   if (!ImeiList) {
        //     empty.show();
        //     return;
        //   }

        //   let html = ImeiList.map(
        //     (i) => `
        //             <tr>
        //                 <td>${i.imei1}</td>
        //                 <td>${i.imei2}</td>
        //                 <td>${i.activation_time}</td>
        //             </tr>            
        //             `
        //   ).join("");
        //   table.show();
        //   tbody.html(html);
        // });
    });
});
